import { takeLatest } from "redux-saga/effects";

import { actionTypes } from "../actions";
import fetchPremiumOffersShopSaga from "./fetchPremiumOffersShopSaga";

export function* watchFetchPremiumOffersShop() {
  yield takeLatest(
    actionTypes.FETCH_PREMIUM_OFFERS_SHOP,
    fetchPremiumOffersShopSaga
  );
}
